module.exports = __webpack_public_path__ + "img/plant_Right.a8bb8267.gif";